module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/about/ABOUT_04_nakhonpathom_05.png";